import { render } from "./VF-badge.vue?vue&type=template&id=4d1e118e&scoped=true"
import script from "./VF-badge.vue?vue&type=script&lang=js"
export * from "./VF-badge.vue?vue&type=script&lang=js"

import "./VF-badge.vue?vue&type=style&index=0&id=4d1e118e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d1e118e"]])

export default __exports__